import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBox16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconBox16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.33 14.665a1.5 1.5 0 0 0 1.34 0l5.777-2.889a1 1 0 0 0 .553-.894V5.427a1.5 1.5 0 0 0-.83-1.342L8.448 1.224a1 1 0 0 0-.894 0L1.829 4.085A1.5 1.5 0 0 0 1 5.427v5.455a1 1 0 0 0 .553.894zM2.275 11.02A.5.5 0 0 1 2 10.573v-4.61a.25.25 0 0 1 .362-.223l4.862 2.43a.5.5 0 0 1 .276.448v4.61a.25.25 0 0 1-.362.223zm.848-6.464a.25.25 0 0 0 0 .447L7.776 7.33a.5.5 0 0 0 .448 0l4.652-2.326a.25.25 0 0 0 0-.447L8.224 2.23a.5.5 0 0 0-.448 0zM13.638 5.74a.25.25 0 0 1 .362.224v4.609a.5.5 0 0 1-.276.447l-4.862 2.431a.25.25 0 0 1-.362-.224V8.619a.5.5 0 0 1 .276-.447z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBox16);
